export default __webpack_public_path__ + "static/media/checkout-demo-bg.8aaeebbb.png";